import React from 'react';
import AccountForm from './AccountForm';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { KEY } from 'web/components/utils/stripeKey';

const VerifyModal = ({ isOpen, toggle, callBackModal, accountResponse, individual, callBackFetchApi, content, link, onClickHander, selectedAchAccountForVerify }) => {
  const stripePromise = loadStripe(KEY);
  return (<>
    <Elements stripe={stripePromise}>
      <AccountForm
        isOpen={isOpen}
        toggle={toggle}
        individual={individual}
        accountResponse={accountResponse}
        onClickHander={onClickHander}
        callBackModal={callBackModal}
        selectedAchAccountForVerify={selectedAchAccountForVerify}
        content=""
        link="" />
    </Elements>
  </>
  );
};

export default VerifyModal;
